import { styled } from '../../../../../utils/styled';
import { propStyles } from '../../../../../utils/propStyles';
import Icon from '../../../../Icon';

const StyledComponent = styled<any, any>(
    Icon,
    'toastCloseIcon',
    'feedback-toast'
)`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    width: '16px',
    height: '16px',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toast/StyledComponents/ToastCloseIcon.tsx